<template>
    <div class="d-lg-flex justify-content-between align-items-center mb-3">
        <form class="form form--sorting">
            <!-- mobile sort select -->
            <div class="d-lg-none">
                <select
                    v-model="localSort"
                    class="form-select form-select-sorting"
                    :aria-label="sortByLabel"
                >
                    <option disabled value="">{{ sortByLabel }}</option>
                    <option
                        v-for="(label, key) in sortingOptions"
                        :key="key"
                        :value="key"
                    >
                        {{ label }}
                    </option>
                </select>
            </div>

            <!-- desktop sort radio list -->
            <ul class="list-unstyled d-none d-xl-flex m-0 p-0 w-100 overflow-auto me-xl-5">
                <li
                    v-for="(label, key) in sortingOptions"
                    :key="key"
                    class="text-nowrap me-3"
                >
                    <label class="sortingMobileInput">
                        <input
                            type="radio"
                            v-model="localSort"
                            :value="key"
                        />
                        <span>{{ label }}</span>
                    </label>
                </li>
            </ul>
        </form>

        <div class="d-none d-lg-flex align-items-center">
      <span class="text--semi-small text-nowrap text--grey-200">
        {{ totalResultsText }}
      </span>
        </div>
    </div>
</template>

<script setup>
import { useCarFilterSorting } from '@/composables/useCarFilterSorting';

const props = defineProps({
    sort: { type: String, required: true },
    sortingOptions: { type: Object, required: true },
    sortByLabel: { type: String, required: true },
    totalResultsText: { type: String, required: true },
});

const emit = defineEmits(['update:sort']);

const { localSort } = useCarFilterSorting(props, emit);
</script>
